var render, staticRenderFns
import script from "./DesignSubTable.vue?vue&type=script&lang=js&"
export * from "./DesignSubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('275c0a05')) {
      api.createRecord('275c0a05', component.options)
    } else {
      api.reload('275c0a05', component.options)
    }
    
  }
}
component.options.__file = "src/packages/DesignSubTable.vue"
export default component.exports